import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matt Stayner
 * id 61B5D6E3-5706-401F-8D18-3145A446C543
 * name arrow-right-thin
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-thin.svg
 * tags
 * - Arrow 
 */
export const ArrowRightThinIcon = createSvgIcon(<><path d="M14 16.94V12.94H5.08L5.05 10.93H14V6.94L19 11.94Z" /></>, 'ArrowRightThinIcon');
export default ArrowRightThinIcon